import { Link } from "react-router-dom";
import { allGenres, allWorks } from "@/utils/catalog";

const stats = [
  { value: `${allWorks.length}+`, label: "收录影视作品" },
  { value: `${allGenres.length}+`, label: "题材标签" },
  { value: "3", label: "内容分类" },
  { value: "100%", label: "剧情深度解读" },
];

export default function SiteIntro() {
  return (
    <section className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
      <div className="grid grid-cols-1 gap-8 p-6 md:grid-cols-2 md:p-10">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wider text-accent-600 uppercase">
            <span className="h-3 w-1 rounded-full bg-accent-500"></span>
            关于妻子的朋友
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            让每一部影视剧，都值得被认真看懂
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            妻子的朋友专注于为影视爱好者提供详实的剧情介绍、角色分析与观影推荐。
            无论你是想快速了解一部剧的剧情走向，还是希望找到同类型的高口碑作品，
            这里都能帮你用更少的时间，找到更值得看的内容。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/special"
              className="flex h-11 items-center gap-2 rounded-md bg-primary-500 px-5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-bookmark-3-line"></i>
              </span>
              浏览专题合集
            </Link>
            <Link
              to="/about"
              className="flex h-11 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="flex flex-col justify-center rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="font-heading text-3xl font-black text-primary-600">{s.value}</span>
              <span className="mt-1 text-xs text-foreground-600">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}